import * as Config from '../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './FilterSelect.css';

import ArrowUp from '../svg/ChevronUp';
import ArrowDown from '../svg/ChevronDown';

// Dropdown Filter Select
function FilterSelect({ values, selected, onSelected, width, height, className, style }) {
  const [active, setActive] = useState(false);

  const selectFilter = (selectedValue) => () => {
    onSelected(selectedValue);
    setActive(false);
  };

  const showContextMenu =  () => { setActive(state => !state); }

  return (
    <>
      <div className={`flexRow ${className} input-box filter-select ${active && `active`} `} style={{...style, width}} onClick={showContextMenu} >
        {selected}
        {active ? <ArrowUp color={Config.TYPE_SECONDARY} /> : <ArrowDown color={Config.TYPE_SECONDARY} />}
      </div>
      <div className={`filter-select-content flexColumn ${active && `on`}`} style={{ height, width: width - 8 }}>
        { values.map( (x, i) => <span key={`FS${i}`} className={`filter-select-item`} onClick={selectFilter(i)}>{x}</span> ) }
      </div>
    </>
  )
}

FilterSelect.propTypes = {
  values: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  onSelected: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default FilterSelect;
